import React from 'react'
import LabDrawer from '../../components/drawers/dentalLab'
import BilledQueue from '../../components/pages/billedQueue'

const Lab = () => {
    return (
        <BilledQueue
            category="Dental-Lab"
            basePath="/app/dental/lab"
            DrawerComponent={LabDrawer}
            forwardSource="Dental-Lab"
            requestDepartment="Dental-Lab"
        />
    )
}

export default Lab
